export default __webpack_public_path__ + "static/media/sbo-provider.21bd8e79.webp";